export default {
    change_script_title: "Cambiar Script",
    change_script_label: "Script",
    change_script_input: "IMEI o serie",
    change_script_imei: "IMEI",
    change_script_serial: "Serie",
    change_script_model: "Modelo",
    change_script_change: "Cambiar",
    change_script_no_devices_added: "No se han añadido dispositivos",
    change_script_device_is_already_added: "El dispositivo ya está añadido",
    change_script_device_has_not_been_found: "No se ha encontrado el dispositivo",
    change_script_this_feature_is_not_available: "Esta función no está disponible",
    change_script_single_success_message: "El Script del dispositivo ha sido cambiado",
    change_script_multiple_success_message: "Se ha actualizado el Script de los dispositivos",
    change_script_error_message: "No se puede cambiar el Script debido a un error",
    change_script_pre_loaded_script: "Script Pre-Cargado",
    change_script_assigned_script: "Script Asignado",
    change_script_script: "Script",
    change_script_assign: "Asignar",
    change_script_no_script_devices: "Hay dispositivos que no tienen el script configurado",
    change_script_transaction_request_message:"Se ha recibido la solicitud de cambio de script de los dispositivos. Haga clic aquí para ver el estado del cambio.",
    change_script_warning_message_calamp_api:"Los dispositivos seleccionados deben ser del mismo calamp api",
    change_script_calamp_api:"Api de Calamp",
    change_script_no_devices_selected: "No hay dispositivos seleccionados",
    change_script_no_scripts_selected: "No hay scripts seleccionados",
}